import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { ContactForm } from "../components";
import { Helmet } from "react-helmet-async";

const Contact = () => {
  return (
    <>
      <Helmet>
        <title>Contact | GabyLen Autoservice & ITP Florești</title>
        <meta
          name="description"
          content="Contactează GabyLen Autoservice & ITP din Florești, Cluj pentru informații sau rezervări ITP, reparații auto și multe altele. Suntem aici să te ajutăm!"
        />
        <meta
          name="keywords"
          content="contact GabyLen Autoservice, contact service auto Florești, rezervare ITP Florești, reparații auto Florești Cluj, informații GabyLen autoservice, formular contact service"
        />
      </Helmet>
      <div className="bg-gray-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Contactați-ne!
            </h1>
            <p className="text-gray-600">
              Contactați-ne astăzi pentru mai multe informații!
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-12">
            <div className="bg-white p-8 rounded-lg shadow-sm">
              <h2 className="text-2xl font-semibold mb-6">Contact</h2>
              <div className="space-y-4">
                <div className="flex items-center space-x-4">
                  <MapPin className="text-red-600" />
                  <span>
                    <a
                      href={"https://maps.app.goo.gl/i6bXXtAxihNcnvaK9"}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-500 hover:underline"
                    >
                      Strada Porii, nr. 162, comuna Florești, jud. Cluj
                    </a>
                  </span>
                </div>
                <h3 className="text-1xl font-semibold mt-8">Mecanică & ITP</h3>
                <div className="flex items-center space-x-4">
                  <Phone className="text-red-600" />
                  <span>0772006950</span>
                </div>
                <div className="flex items-center space-x-4">
                  <Mail className="text-red-600" />
                  <span>gabylenmecanica@gmail.com</span>
                </div>
                <div className="flex items-center space-x-4">
                  <Clock className="text-red-600" />
                  <span>Luni-Vineri: 09:00-17:00</span>
                </div>
                <h3 className="text-1xl font-semibold mt-8">
                  Tinichigerie & Vopsitorie
                </h3>
                <div className="flex items-center space-x-4">
                  <Phone className="text-red-600" />
                  <span>0772005574</span>
                </div>
                <div className="flex items-center space-x-4">
                  <Mail className="text-red-600" />
                  <span>gabyautoservice@gmail.com</span>
                </div>
                <div className="flex items-center space-x-4">
                  <Clock className="text-red-600" />
                  <span>Luni-Vineri: 08:00-16:00</span>
                </div>
              </div>
            </div>
            <ContactForm />
          </div>
          <div className="mt-8">
            <p className="text-xs text-gray-500 ">Date comerciale</p>
            <p className="text-xs text-gray-500 ">Gabylen Auto Service SRL</p>
            <p className="text-xs text-gray-500">J12/123/2012</p>
            <p className="text-xs text-gray-500">RO29573235</p>
            <p className="text-xs text-gray-500">Sediu: Com. Mărișel nr. 258</p>
            <p className="text-xs text-gray-500">
              Punct de lucru: Florești, str. Porii, nr. 162A
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
